import { Langs } from '@/locales';
import { useRouter } from 'next/router';

export function useLocale() {
  const { locale } = useRouter();
  return (locale || 'pt-BR') as Langs;
}
